/**
 * Validacao de CNPJ com suporte ao formato alfanumerico (vigente a partir de
 * 2026): os 12 primeiros caracteres podem ser letras (A-Z) ou numeros (0-9) e
 * os 2 ultimos sao digitos verificadores numericos. O CNPJ numerico tradicional
 * e um subconjunto deste formato e continua valido.
 *
 * O calculo dos DVs usa mod-11 com o valor de cada caractere = (ASCII - 48).
 */

// Remove a formatacao e normaliza para maiusculo, preservando as letras do
// CNPJ alfanumerico.
export function cleanCnpj(value) {
  return (value || "").toUpperCase().replace(/[^A-Z0-9]/g, "");
}

function charValue(char) {
  // '0'-'9' -> 0-9 ; 'A'-'Z' -> 17-42
  return char.charCodeAt(0) - 48;
}

function calcCheckDigit(base) {
  let weight = base.length === 12 ? 5 : 6;
  let sum = 0;

  for (let i = 0; i < base.length; i++) {
    sum += charValue(base[i]) * weight;
    weight--;
    if (weight < 2) weight = 9;
  }

  const mod = sum % 11;
  return mod < 2 ? 0 : 11 - mod;
}

export function isValidCnpj(value) {
  const cnpj = cleanCnpj(value);

  if (cnpj.length !== 14) return false;
  if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(cnpj)) return false;
  if (/^(.)\1{13}$/.test(cnpj)) return false;

  const dv1 = calcCheckDigit(cnpj.substring(0, 12));
  const dv2 = calcCheckDigit(cnpj.substring(0, 13));

  return dv1 === Number(cnpj[12]) && dv2 === Number(cnpj[13]);
}
